<template>
  <div class="ChongzhiRecordPage-wrapper">
    <!-- 标题 -->
    <!-- <van-empty v-if="this.list.length == 0" description="暂无收藏记录" /> -->
    <!-- 空图片 -->
    <div class="empty-pic" >
      <img v-if="this.list.length == 0" class="empty-img"
        :src="require('../../../assets/imgs/collect/collect_empty.png')" />

    </div>
    <van-list v-model="loading" :finished="finished" :finished-text="this.list.length != 0 ? '— 我是有底线的 —' : ''"
      @load="onLoad">
      <van-cell class="item-wrapper" v-for="(item, index) in list" :key="index">
        <div class="up-wrapper" @click="onClickArticle(item.articleId)">
          <div class="item-left">
            <img v-if="item.isFree" class="vip-icon" :src="require('../../../assets/imgs/collect/collect_free.png')" />
            <img v-else class="vip-icon" :src="require('../../../assets/imgs/collect/collect_vip.png')" />

            <!-- <img style="width: 22px;height: 10px;position: absolute;right: 6px;"
              :src="require('../../../assets/imgs/collect/collect_free.png')" /> -->

            <img class="item-img" :src="item.subImageUrl" @click="onClickClose" />

          </div>

          <div class="article-collection-list-item-text-container">
            <div v-if="item.titleCn" class="article-item-title-cn">
              {{ item.titleCn.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.title" class="article-item-title-en">
              {{ item.title.replace(/&nbsp;/g, " ") }}
            </div>
             <img v-if="item.isRead" class="collect-readed"
              :src="require('../../../assets/imgs/collect/collect_readed.png')" />
          </div>
        </div>
        <!-- <p>{{getChangeType(item.source)}}-{{item.rewardPointGoodsName}}</p> -->
      </van-cell>
    </van-list>
  </div>
</template>

<script>
  import { rewardPointGoodsHistory } from "../../../api/scoreshop";
  import { collectionList } from '../../../api/collection'
  import { dateFormat } from "@/lib/util";
  //{ amount: 1, rewardPointGoodsName: 'p' }
  export default {
    data() {
      return {
        list: [],
        loading: false,
        finished: false,
        page: 0,
      }
    },

    created() {

    },

    activated() {

    },

    methods: {
      onClickArticle(articleId) {
        console.log('----id---' + articleId)
        this.$router.push({
          path: "/articleGuide",
          query: { articleId: articleId }
        })
      },
      onClickClose() {
        console.log('---close---')
        this.$router.go(-1)
      },

      createTime(time) {
        return dateFormat(time, 'YYYY-MM-DD hh:mm')
      },

      //兑换类型
      getChangeType(source) {
        if (source == 1) {
          return '阅读奖励'
        } else if (source == 2) {
          return '答题奖励'
        } else if (source == 3) {
          return '兑换奖励'
        }
      },

      onLoad() {
        //加载列表数据
        setTimeout(() => {
          this.requset_rewardPointGoodsHistory()
          this.request_collect()
        }, 500)
      },

      //加载收藏的数据
      request_collect() {
        let _THAT = this;
        let params = { pageIndex: _THAT.page, pageSize: 30 };
        collectionList(params).then(res => {
          _THAT.loading = false;
          if (res.code === 0) {
            if (_THAT.page == 1) {
              // _THAT.list = [];
            }

            if (res.data.records && res.data.records.length > 0) {
              _THAT.list.push(...res.data.records)
            }
            if ((res.data.records && res.data.records.length < 30) || (!res.data.records)) {
              _THAT.finished = true;
            }
            _THAT.page++;
          } else {
            _THAT.finished = true;
          }
        }).catch((err => {
          this.$toast(JSON.stringify(err))
          _THAT.loading = false;
          _THAT.finished = true;
        }))
      },
      //加载订单数据
      requset_rewardPointGoodsHistory() {
        let _THAT = this;
        let params = { pageIndex: _THAT.page, pageSize: 30 };
        rewardPointGoodsHistory(params).then(res => {
          _THAT.loading = false;
          if (res.code === 0) {
            if (_THAT.page == 1) {
              // _THAT.list = [];
            }

            if (res.data.records && res.data.records.length > 0) {
              // _THAT.list.push(...res.data.records)
            }
            if ((res.data.records && res.data.records.length < 30) || (!res.data.records)) {
              _THAT.finished = true;
            }
            _THAT.page++;
          } else {
            _THAT.finished = true;
          }
        }
        ).catch((err) => {
          this.$toast(JSON.stringify(err))
          _THAT.loading = false;
          _THAT.finished = true;
        })
      },

      //================================================
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .ChongzhiRecordPage-wrapper {
    box-sizing: border-box;
    min-height: 100vh;
    /* padding: 8px 20px; */
    background-color: #F3F5F9;
    font-size: 14PX;
    color: #333;
    overflow: hidden;
  }

  .item-wrapper {
    background-color: #F3F5F9;
    margin-top: 8px;
    border-radius: 6px;
    padding: 10px 10px;
    font-size: 14PX;
    color: #999;

    .up-wrapper {
      display: flex;
      /* justify-content: center; */
      padding: 0, 20px, 12px 20px;
      flex-direction: row;

      .lf-title {
        color: #5597EC;
        font-weight: bold;
        font-size: 16PX;
      }
    }

  }

  titleView {
    height: 80px;

    background-color: #5597EC;

    .title-image {
      height: 21px;
      widows: 20px;
    }

    .title-text {
      color: #5597EC;
    }
  }

  .vip-icon {
    width: 22px;
    height: 10px;
    position: absolute;
    right: 5px;
    top: 5px
  }

.article-collection-list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 12px;
}

.article-item-title-en {
  font-family: serif, SimSun, STSong;
  font-size: 11px;
}

.article-collection-title {
  margin-top: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin-top: 20px;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin-top: 20px;
  font-size: 11px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  margin: 10px 0 20px 0;
  color: #3994E7;
}

.empty-pic {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.empty-img {
  width: 254px;
  height: 200px;
  align-self:center;
  margin-top: 142px
}

.collect-readed {
  width: 28px;
  height: 13px;
  margin-top: 4px;
  margin-left: -4px
}

.item-img {
  width: 81px;
  height: 80px;
  border-radius: 5px
}

.item-left {
  padding: 2px;
  position: relative;
}
</style>


// WEBPACK FOOTER //
// app/pages/tabs/Mine/MyCollect.vue